export default __webpack_public_path__ + "static/media/Group 1413.70d2d62c.png";